import React from 'react'
import {BaseDialog, Role} from 'dialogs/BaseDialog'
import Table from 'common/Table';
import {getMessage as msg} from 'MessageBundle'
import moment from 'moment';
import theme from './BusinessLog.scss'
import conf from 'configuration.json';

export default class BusinessLog extends BaseDialog {

    constructor(props) {
        super(props);

        const path = this.props.match.path; // current location path, e.g. /edit
        const pathname = this.props.location.pathname; // current location pathname, e.g. /edit/<complaintNumber>
        try {
            this.complaintNumber = atob(pathname.replace(path + "/", ""));
        } catch (e) {
            window.location.href = '/';
        }

        this.tableStructure = [
            {
                attribute: "basket", label: msg("basketHistory.column.basket"), title:  msg("basketHistory.column.basket"),
                width: '200px',
                render: (row) => row.basket
            },
            {
                attribute: "arrived", label: msg("basketHistory.column.timestamp"), title:  msg("basketHistory.column.timestamp"),
                width: '200px', bodyStyle: theme.txtRight,
                render: (row) => moment(row.arrived).format('DD.MM.YY, HH:mm')
            }
        ];
    }

    componentDidMount() {
        super.init(() => {
            this.request('get', conf.rest.businessLogEndpoint + '/' + this.complaintNumber).send((result) => {
                this.setState({
                    businessLog: result.body,
                    initialized: true
                });
            })
        });
    }

    getAllowedRoles() {
        return [Role.VPQ_OPERATOR];
    }

    getDialog() {
        return (
            <div className={theme.basketHistory}>
                <h3>{msg('basketHistory.header')}</h3>
                <div className={theme.clear}>
                    <div className={theme.complaintNumber}>
                        {msg('basketHistory.label.complaintNumber')}
                        <span>{this.complaintNumber}</span>
                    </div>
                    <h4>{msg('basketHistory.subHeader')}</h4>
                    <div className={theme.tblWrap}>
                        <div className={theme.tblWrapInner} tabIndex="0">
                            <Table structure={this.tableStructure} value={this.state.businessLog.basketHistory} />
                        </div>
                    </div>
                    <h4>{msg('basketHistory.digitalFootprintHeader')}</h4>
                    <div tabIndex="0" className={theme.footPrint}>
                        <ul>
                            {this.state.businessLog.digitalFootprint.map((footprint, idx) => {
                                return (
                                    <li key={idx}>
                                        [{moment(footprint.created).format('DD.MM.YY, HH:mm')}] {footprint.value}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                    
                    <button id="basketHistory-close-btn" onClick={this.closeWindow} title={msg("basketHistory.button.close.mouseOver")}>
                        {msg("basketHistory.button.close")}
                    </button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/EditComplaint/BusinessLog/index.js